module.exports = __webpack_public_path__ + "img/ico-cambiar-cuenta-w.56cd4c8d.svg";